<template>
  <div id="flowinity-authorize">
    <v-container>
      <v-card
        v-if="loading && this.$route.params.type === 'link'"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">Loading...</p>
        </v-container>
      </v-card>
      <v-card
        v-if="!loading && linked && this.$route.params.type === 'link'"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">Your Flowinity SSO account has been linked.</p>
        </v-container>
      </v-card>
      <v-card
        v-if="!loading && !linked && this.$route.params.type === 'link'"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">
            Your Flowinity SSO account could not be linked, the error message is
            below:
          </p>
          <p
            v-for="item in $store.state.errorHandler.errors"
            :key="item"
            class="text-subtitle-1"
          >
            {{ item }}
          </p>
        </v-container>
      </v-card>
      <v-card
        v-if="loading && this.$route.params.type === 'login'"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">Logging you in...</p>
        </v-container>
      </v-card>
      <v-card
        v-if="
          !loading &&
          this.$route.params.type === 'login' &&
          !fail &&
          !linkAccount
        "
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">You have been logged in. Redirecting...</p>
        </v-container>
      </v-card>
      <v-card
        v-if="!loading && this.$route.params.type === 'login' && fail"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">
            There was an issue while logging in, the error message is below:
          </p>
          <p
            v-for="item in $store.state.errorHandler.errors"
            :key="item"
            class="text-subtitle-1"
          >
            {{ item }}
          </p>
        </v-container>
      </v-card>
      <v-card
        v-if="
          !loading &&
          this.$route.params.type === 'login' &&
          linkAccount &&
          interim === 'none'
        "
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">
            Would you like to create, or login to an existing account to link?
          </p>
          <v-card-actions class="justify-center">
            <v-btn class="rounded-xl" @click="initRegister">Create </v-btn>
            <v-btn class="rounded-xl" @click="interim = 'login'">Login</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
      <v-card
        v-if="
          !loading &&
          this.$route.params.type === 'login' &&
          linkAccount &&
          interim === 'login'
        "
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">Login with your credentials to link.</p>
          <v-form
            v-if="$store.state.site.enterprise"
            ref="form"
            class="pa-4 pt-6"
          >
            <v-text-field
              class="rounded-xl"
              v-model="login.email"
              label="Email address or Username"
              type="email"
            ></v-text-field>
            <v-text-field
              class="rounded-xl"
              v-model="login.password"
              color="blue accent-7"
              label="Password"
              type="password"
            ></v-text-field>
            <v-text-field
              class="rounded-xl"
              v-model="login.totpCode"
              color="blue accent-7"
              label="2FA Code (if enabled)"
              placeholder="123456"
              type="number"
            >
            </v-text-field>
            <v-divider class="mt-15"></v-divider>
            <v-card-actions>
              <v-btn class="rounded-xl" text @click="initRegister">
                Register instead</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                class="rounded-xl"
                :loading="loading"
                color="primary"
                text
                @click="doLogin()"
              >
                Login & Link
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
    </v-container>
    <v-card
      v-if="loading && this.$route.params.type === 'register'"
      class="rounded-xl"
      elevation="7"
    >
      <v-container class="text-center">
        <p class="text-lg-h4">Creating account...</p>
      </v-container>
    </v-card>
    <v-card
      v-if="!loading && this.$route.params.type === 'register'"
      class="rounded-xl"
      elevation="7"
    >
      <v-container class="text-center">
        <p class="text-lg-h4">Success, redirecting...</p>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "FlowinityAuthorize",
  data() {
    return {
      loading: true,
      linked: false,
      fail: false,
      linkAccount: false,
      interim: "none",
      register: {
        email: "",
        password: "",
        confirmPassword: "",
        loading: false
      },
      login: {
        email: "",
        password: "",
        totpCode: "",
        loading: false
      }
    }
  },
  methods: {
    initRegister() {
      window.location.href =
        "https://sso.flowinity.com/auth/realms/master/protocol/openid-connect/auth?client_id=" +
        this.$store.state.site.flowinityId +
        "&redirect_uri=" +
        this.$store.state.site.hostnameWithProtocol +
        "%2FflowinityAuthorize%2Fregister&response_type=code"
    },
    doRegister() {
      this.loading = true
      this.axios
        .post("/api/v1/auth/register/external/flowinity", {
          code: this.$route.query.code
        })
        .then((res) => {
          this.loading = false
          this.$store.commit("login", res.data)
          localStorage.setItem("token", res.data.token)
          this.$store.commit("updateToken", res.data.token)
          Object.assign(this.axios.defaults, {
            headers: { Authorization: this.$store.state.user.token }
          })
          this.axios
            .get("/api/v1/userutils/info")
            .then((res) => {
              this.$store.commit("login", res.data)
            })
            .catch((e) => {
              AjaxErrorHandler(this.$store)(e)
            })
          this.$router.push("/")
        })
        .catch((e) => {
          this.fail = true
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    doLogin() {
      this.loading = true
      this.axios
        .post("/api/v1/auth/login", {
          email: this.login.email,
          password: this.login.password,
          code: this.login.totpCode
        })
        .then((res) => {
          this.loading = false
          this.$store.commit("login", res.data)
          localStorage.setItem("token", res.data.token)
          Object.assign(this.axios.defaults, {
            headers: { Authorization: this.$store.state.user.token }
          })
          this.$store.dispatch("quickSwitchCache")
          this.axios
            .get("/api/v1/userutils/info")
            .then((res) => {
              this.$store.commit("login", res.data)
              window.location.href =
                "https://sso.flowinity.com/auth/realms/master/protocol/openid-connect/auth?client_id=" +
                this.$store.state.site.flowinityId +
                "&redirect_uri=" +
                this.$store.state.site.hostnameWithProtocol +
                "%2FflowinityAuthorize%2Flink&response_type=code"
            })
            .catch((e) => {
              AjaxErrorHandler(this.$store)(e)
            })
        })
        .catch((e) => {
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    linkDiscord() {
      this.loading = true
      this.axios
        .put("/api/v1/userutils/settings/linkFlowinity", {
          code: this.$route.query.code
        })
        .then(() => {
          this.loading = false
          this.linked = true
        })
        .catch((e) => {
          this.fail = true
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    loginDiscord() {
      this.loading = true
      this.axios
        .post("/api/v1/auth/login/external/flowinity", {
          code: this.$route.query.code
        })
        .then((res) => {
          this.loading = false
          this.$store.commit("login", res.data)
          localStorage.setItem("token", res.data.token)
          Object.assign(this.axios.defaults, {
            headers: { Authorization: this.$store.state.user.token }
          })
          this.axios
            .get("/api/v1/userutils/info")
            .then((res) => {
              this.$store.commit("login", res.data)
              this.$router.push("/")
              this.$toast("You have been logged in.", {
                timeout: 3000,
                type: "success"
              })
            })
            .catch((e) => {
              AjaxErrorHandler(this.$store)(e)
            })
        })
        .catch((e) => {
          this.loading = false
          this.linkAccount = true
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    if (this.$route.params.type === "link") {
      this.linkDiscord()
    } else if (this.$route.params.type === "login") {
      this.loginDiscord()
    } else if (this.$route.params.type === "register") {
      this.interim = "doRegister"
      this.doRegister()
    }
  }
}
</script>

<style scoped></style>
